export default __webpack_public_path__ + "37136be6e9b5a6ab4850c3c6fffe32a7.svg";